import { useAidaOverlayStore } from '../../stores/overlay-store'
import type { AidaPresentationMode } from '../../stores/overlay-store'
import { AidaChatHost } from './aida-overlay-host'
import { AidaDockShell, AidaFloatingShell, AidaFullscreenShell } from './aida-overlay-parts'

export function AidaOverlay() {
  const open = useAidaOverlayStore(state => state.open)
  const mode = useAidaOverlayStore(state => state.mode)

  return <AidaChatHost>{open ? <AidaOverlayMode mode={mode} /> : null}</AidaChatHost>
}

function AidaOverlayMode({ mode }: { mode: AidaPresentationMode }) {
  if (mode === 'fullscreen') {
    return <AidaFullscreenShell />
  }
  if (mode === 'dock') {
    return <AidaDockShell />
  }
  return <AidaFloatingShell />
}
